import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { addNavigationBreadcrumb } from '@/lib/sentry';

/**
 * Tracks route changes as Sentry breadcrumbs for post-mortem debugging.
 * Renders nothing — just observes navigation.
 */
export const NavigationBreadcrumbs = () => {
  const location = useLocation();
  const prevPathRef = useRef(location.pathname);

  useEffect(() => {
    const from = prevPathRef.current;
    const to = location.pathname;
    if (from !== to) {
      addNavigationBreadcrumb(from, to);
      prevPathRef.current = to;
    }
  }, [location.pathname]);

  return null;
};
